import { render, staticRenderFns } from "./EditBlockNavigationTabLogo.vue?vue&type=template&id=0555fa52&scoped=true&"
import script from "./EditBlockNavigationTabLogo.vue?vue&type=script&lang=js&"
export * from "./EditBlockNavigationTabLogo.vue?vue&type=script&lang=js&"
import style0 from "./EditBlockNavigationTabLogo.vue?vue&type=style&index=0&id=0555fa52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0555fa52",
  null
  
)

export default component.exports